import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import BrandSection from './components/BrandSection';
import StatsCounter from './components/StatsCounter';
import GallerySection from './components/GallerySection';
import SemiPermanentSection from './components/SemiPermanentSection';
import MakeupSection from './components/MakeupSection';
import AntiAgingSection from './components/AntiAgingSection';
import DietHerbalSection from './components/DietHerbalSection';
import PricingSection from './components/PricingSection';
import ReviewsSection from './components/ReviewsSection';
import ReservationSection from './components/ReservationSection';
import Footer from './components/Footer';
import SectionDivider from './components/SectionDivider';
import PopupNotice from '@/components/feature/PopupNotice';

export default function HomePage() {
  return (
    <div className="font-sans bg-cream overflow-x-hidden">
      <PopupNotice />
      <Navbar />
      <main>
        <HeroSection />
        <BrandSection />
        <StatsCounter />
        <SectionDivider variant="ornament" />
        <GallerySection />
        <SectionDivider variant="branch" />
        <SemiPermanentSection />
        <SectionDivider variant="floral" />
        <SectionDivider variant="ornament" />
        <AntiAgingSection />
        <SectionDivider variant="floral" />
        <DietHerbalSection />
        <SectionDivider variant="branch" />
        <MakeupSection />
        <PricingSection />
        <SectionDivider variant="ornament" />
        <ReviewsSection />
        <SectionDivider variant="floral" />
        <ReservationSection />
      </main>
      <Footer />
    </div>
  );
}
